import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, useSlots } from 'vue';
import TrashSvg from '@/assets/icons/trash.svg';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseButtonField',
  props: {
    value: null,
    label: null,
    placeholder: null,
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    loading: { type: Boolean },
    clearable: { type: Boolean },
    clearableType: { default: 'inner' },
    view: { default: 'border-bottom' },
    size: { default: 'large' },
    smallSize: { type: Boolean }
  },
  emits: [
    'focus',
    'blur',
    'clear',
    'click',
],
  setup(__props: any, { emit: emits }) {

const props = __props as { value?: any, label?: string, placeholder?: string, disabled?: boolean, readonly?: boolean, loading?: boolean, clearable?: boolean, clearableType: 'inner' | 'out', view: 'border-bottom' | 'outlined' | 'empty', size: 'small' | 'medium' | 'large', smallSize?: boolean }



const slots = useSlots();

const isHandleLabelMove = ref<boolean>(false);

const getClasses = computed<string[]>(() => {
    return [
        props.view === 'outlined' && 'is-outlined',
        props.view === 'border-bottom' && 'is-border-bottom',
        props.view === 'empty' && 'is-empty',
        props.disabled && 'is-disabled',
        isLabelMove.value && 'is-label-move',
        props.loading && 'is-loading',
        props.readonly && 'is-readonly',
        props.smallSize && 'is-small',
        props.size && `is-size-${props.size}`,
    ];
});

const isShowClearable = computed<boolean>(() => {
    return props.clearable && props.value && !props.disabled && !props.readonly;
});

const isLabelMove = computed<boolean>(() => {
    return props.label && (isHandleLabelMove.value || props.value);
});

const labelOffset = computed<string>(() => {
    if (slots['prepend-icon']) {
        if (isLabelMove.value) {
            return 'inset: -14px 0 0 9px;';
        } else {
            return 'inset: 10.7px 0 0 34px;';
        }
    } else {
        if (isLabelMove.value) {
            return 'inset: -14px 0 0 9px;';
        } else {
            return 'inset: 10.7px 0 0 9px;';
        }
    }
});

const handleFocus = (): void => {
    emits('focus');

    if (!(props.readonly || props.disabled)) {
        isHandleLabelMove.value = true;
    }
};

const handleBlur = (): void => {
    emits('blur');

    if (!(props.readonly || props.disabled)) {
        isHandleLabelMove.value = false;
    }
};

const handleClear = (): void => {
    emits('clear');
};

return { __sfc: true,props, emits, slots, isHandleLabelMove, getClasses, isShowClearable, isLabelMove, labelOffset, handleFocus, handleBlur, handleClear, TrashSvg }
}

})